/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wide_Safe_Larva_InspireInputs */

const en_wide_safe_larva_inspire = /** @type {(inputs: Wide_Safe_Larva_InspireInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Shared Content`)
};

const de_wide_safe_larva_inspire = /** @type {(inputs: Wide_Safe_Larva_InspireInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Geteilte Inhalte`)
};

/**
* | output |
* | --- |
* | "Shared Content" |
*
* @param {Wide_Safe_Larva_InspireInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const wide_safe_larva_inspire = /** @type {((inputs?: Wide_Safe_Larva_InspireInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wide_Safe_Larva_InspireInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_wide_safe_larva_inspire(inputs)
	return de_wide_safe_larva_inspire(inputs)
});